define('views/user/register/financial/memberapplication',[
    "backbone",
    "views/_base/baseview",
    "text!views/user/register/financial/memberapplication.html",
    "views/user/cardholderagreement/cardholderagreement",
    "models/shared/lookups/states",
    "models/shared/lookups/systext",
    "models/shared/securityquestions/securityquestion",
    "models/shared/securityquestions/securityquestion_collection",
    "models/shared/lookups/lookups",
    "models/shared/user/user",
    "views/user/register/financial/identityconfirmation",
    "views/user/register/financial/success",
    "views/user/register/financial/failure",
    "views/user/register/financial/questionsandanswers",
    "models/shared/qanda/questionandanswers",
    "views/user/register/financial/visaredirect",
    "views/user/register/financial/productselection",
    "css!vendors/jquery/datetimepicker/2.2.9/jquery.datetimepicker",    
    "css!vendors/jquery/tooltipster/tooltipster.css"
], function(Backbone, BaseView, Template, CardholderAgreement, States, SystemText, SecurityQuestion, SecurityQuestionCollection, Lookups, User, IdentityConfirmation, SuccessView, FailureView, QsandAsView,  QuestionandAnswers, VisaRedirect,  ProductSelectionView, DatePicker, ToolTipsterCSS){
    "use strict";

    return BaseView.extend({
        tagName  : "section",
        id       : "financialRegister",
        isRender : false,
        needsAuth: true,
        activityIndicator: false,
        template : _.template(Template),
        model    : null,
        events   : {
            'click'               : 'resetTimer',
            "click #continueReg"  : "continueRegistration",
            "click #cardHldrAgrmt": "toggleContinue",
            "click #contactUsBtn" : "contactUs",
            "click .js-showAgreement": "showAgreement",
            "blur .month"         : "monthTouched",
            "blur .day"           : "dayTouched",
            "blur .year"          : "yearTouched",
            "blur input"          : "validateApplication",
            "keyup #homePhone"    : "validatePhone",
            'keyup #mobile'       : 'appendPh',
            "change"              : "validateApplication",
            "focus input"         : "showToolTip"
        },
        initialize: function (options) {
            var that = this,
                options = options || {};

            this.securityQuestions = new SecurityQuestionCollection();
            this.QandAmodel = null;
            this.QandAs = new QuestionandAnswers();
            this.states = new Lookups();
            this.user = null;
            this.timeOut = 0;
            this.isBcbsla = options.isBcbsla;
            this.addInfo = options.addInfo;
            this.product = options.product;
            this.numFailuresInSession = 0;
            this.triggerRoute = getCipTriggerRoute();
            this.isTrigger = options.isTrigger;
            
            that.isRegistration = 0;
            store.getStoreItem(enums.modelsEnum.IsRegistration, null, false, false, false, function (data) {
                that.isRegistration = data;
            });

            // If we arrive from a triggered event, i.e. Not CIP'd, then show the form by modyfing the following key
            if(this.triggerRoute){

                if(pf.IsConsumerFinancial){

                    pf.IsConsumerFinancial = false;
                    this.consumerIsFinancial = true;

                } else {

                    this.consumerIsFinancial = false;

                }

            }

            this.monthFocused = false;
            this.dayFocused = false;
            this.yearFocused = false;

            this.site_version = pf.content.version.number;
            this.eligibility_required = pf.session.get('Eligibility');

            this.elementName = options.elementName;
            BaseView.prototype.initialize(this);
        },
        render: function(){

            // console.log('memberapplication render',!pf.IsConsumerFinancial && !pf.IsZCardholder, this.triggerRoute, pf.IsConsumerFinancial, pf.IsZCardholder);
            
            if(!pf.IsConsumerFinancial && !pf.IsZCardholder || this.triggerRoute){

                if(this.model){
                    var that = this;

                    var userName = this.model.attributes.FirstName + " " + this.model.attributes.FirstName;// pf.session.get("FirstName") + " " + pf.session.get("LastName");

                    var email = pf.session.get("eMail");

                    this.$el.html(this.template({ userName: userName, email: email, user: this.model.toJSON() }));
                    var thisYear = new Date().getFullYear();
                    this.$('#dob').combodate({
                        minYear: ( thisYear - 110 ),
                        maxYear: ( thisYear - 18 ),
                        smartDays: true,
                        template: 'MMM D YYYY',
                        format: 'MM/DD/YYYY',           // data-format= data-template=              
                        firstItem:'name'
                    });

                    if (this.model != null || this.model != undefined) {
                        var Data = this.model.toJSON();
                        this.states.fetch({
                            url: pf.lookupsURL + "/States",
                            success: function (cmodel, resp) {
                                that.renderLookups("#state", that.states);
                                that.$("#state option[value='" + (Data.StateID === undefined ? -1 : Data.StateID) + "']").attr("selected", "selected");
                                that.validateEach.validateState(false, null, that);
                            }
                        });
                        //that.$("#gender option[value='" + (Data.Gender === undefined ? 0 : Data.Gender) + "']").attr("selected", "selected");
                    }

                    if (this.product == enums.cardTypes.GPRDebitCard)
                        this.$("#agreementCB").append("<label class='toggleInputLabel' for='cardHldrAgrmt'><input type='checkbox' id='cardHldrAgrmt' name='cardHldrAgrmt' value='0' />I accept the terms of the <a href='/cardholderagreement' target='_blank'>Cardholder Agreement</a></label>");
                    else
                        this.$("#agreementCB").append("<label class='toggleInputLabel' for='cardHldrAgrmt'><input type='checkbox' id='cardHldrAgrmt' name='cardHldrAgrmt' value='0' />I accept the terms of the <a href='/accountholderagreement' target='_blank'>Accountholder Agreement</a></label>");


                    //this.$("#continueReg").attr('disabled', true);

                    // If you're coming from Social Registration, check Partner Opt-In flag
                    if(this.isBcbsla){
                        this.$('#smsEmailOptIn').show();
                    }

                    // If you're continuing your financial registration make a call to check Partner Opt-In flag
                    if(this.isBcbsla == undefined){
                        this.checkOptInStatus(function(optIn){
                            if(optIn.Required){
                                that.$('#smsEmailOptIn').show();
                            }
                        });
                    }
                    

                    that.model.set({ ssnRequired: true });                    

                    $.fn.tooltipster("setDefaults", {
                        position: "bottom"
                    });

                    //this.$(".combodate").on("focusout",function (e) {
                    //    that.validateEach.validateDOB(false, e, that);
                    //});

                    this.delegateEvents();
                    
                }

            }

            if(this.triggerRoute){
                // Reset workaround
                pf.IsConsumerFinancial = this.consumerIsFinancial;
            }

            // TODO: Add check for eligibility on the User object. If it is on, then do not hide.
            if(!this.isTrigger && !this.eligibility_required){
                this.hideSensitiveFields();
            }

            return this;
        },

        hideSensitiveFields: function(){

            this.$('#dob').parent().parent().parent().hide();
            this.$('#ssn4').parent().parent().parent().hide();

        },

        checkOptInStatus: function(callback){

            $.ajax({
                async: false,
                type: 'GET',
                url: pf.lookupsURL + '/OptInWithPartner/' + pf.session.get('UserGUID'),
                contentType: "application/json",
                success: function (resp) {
                    if(callback){
                        callback(resp);
                    }
                },
                error: function (err) {}
            });

        },
        renderLookups: function (selector, values) {

            var that = this;

            if (values != null) {
                values.each(function (n) {
                    var option = "";
                    option = $("<option value=" + n.ID + ">" + n.Name + "</option>");
                    $(selector).append(option);
                });
            }
        },
        resetTimer: function () {
            store.idleTime = 0;
        },
        loadData: function () {

            var that = this;

            if (this.model == null || this.model == undefined) {
                store.getStoreItem(enums.modelsEnum.UserInfo, { ID: pf.session.get("UserGUID") }, false, true, true, function (Data) {
                    that.model = new User(Data);
                    that.render();                    
                    that.validateEach.validateFirstName(false, null, that);
                    that.validateEach.validateLastName(false, null, that);                    
                    that.validateEach.validateCity(false, null, that);                    
                    that.validateEach.validateZipCode(false, null, that);

                    /* modified by Palash to populate DOB from first screen */
                    var dob = pf.session.get('dob');
                    if (dob != null && dob != undefined)
                    {
                        var dobParts = dob.split('/');
                        if (dobParts.length == 3)
                        {
                            var m = parseInt(dobParts[0]),
                                d = parseInt(dobParts[1]),
                                y = parseInt(dobParts[2]);

                            var monthEl = $(".month"),
                                dayEl = $(".day"),
                                yearEl = $(".year"),
                                dobEl = $("#dob");
                            dobEl.val(dob);
                            dayEl.val(d);
                            monthEl.val(m - 1);
                            yearEl.val(y);

                        }
                    }

                    // If Chrome web browser, change the autocomplete attribute
                    if(!!window.chrome && !!window.chrome.webstore){
                        $('#ssn4').attr('autocomplete','new-password');
                    }

                });
            } else {
                this.render();

            }
        },
        // cancelReg: function (e) {

        //     if (e && e.preventDefault) { e.preventDefault(); }
        //     if (e && e.stopPropagation) { e.stopPropagation(); }

        //     pfdialog.confirm({
        //         context: this,
        //         okButtonText: "Yes",
        //         cancelButtonText: "No",
        //         Body: "If you Cancel now, your application will not be saved, and you will not experience the benefits of becoming a financial member of PayForward.\n You may re-start the application process again later, at any time. \n\n Are you sure you wish to cancel your PayForward Prepaid Visa Debit Card application?",
        //         Title: "Cancel",
        //         okCallback: this.confirmCancel
        //     });
        // },
        confirmCancel: function (context) {
            context.cleanup();
            if (!isInApp()) {
                pf.navigate("");
            }
        },

        reRouteAfterCIP: function(){
            var route = getCipTriggerRoute();

            pf.navigate(route);
            // window.location.hash = 'wallet';
            removeCipTriggerRoute();
            // window.location.reload();
        },
        
        continueRegistration: function (e) {
            if (e && e.preventDefault) { e.preventDefault(); }
            if (e && e.stopPropagation) { e.stopPropagation(); }

            this.monthTouched();
            this.dayTouched();
            this.yearTouched();

            if (this.validateApplication(e)) {
                this.$("#continueReg").attr('disabled', true);
                this.$("#continueReg").addClass("btn-showSpinner");
                // this.$("#cancelReg").attr('disabled', true);
                this.$(".formSection").attr('disabled', true);

                //var genderval = "";
                //var gender = this.$("#gender").val();

                //if (gender == 1)
                //    genderval = "Male";
                //else if (gender == 2)
                //    genderval = "Female";
                //else if (gender == 3)
                //    genderval = "Declined to answer"

                var that = this;
                this.model.set("SSN4", that.model.attributes.SSN4);
                this.model.set("Email", pf.session.get("eMail"));
                this.model.set("FirstName", this.$("#firstName").val());
                this.model.set("LastName", this.$("#lastName").val());

                this.model.set("CardType", this.product);

                this.model.set("SMS", this.$('#smsCheckbox').is(":checked"));
                this.model.set("OIWP", this.$('#smsEmailCheckbox').is(":checked"));

                var saveModel = this.model;
                
                this.model.set({ Email: encrypt(this.model.get("Email")), DOB: encrypt(this.model.get("DOB")), SSN4: encrypt(this.model.get("SSN4")), SSN: encrypt(this.model.get("SSN")), PhoneNumber: encrypt(this.model.get("PhoneNumber")) });

                gAnalytics('FinancialSignUp', 'Continue', 'Clicked');

                var application_endpoint = pf.consumerURL + ((this.isTrigger) ? '/CIP' : '/Application');

                this.model.save(null, {
                    url: application_endpoint,
                    success: function (model, resp) {
                        pf.session.getAuth(function () { });
                        that.$(".formSection").attr('disabled', false);
                        var Message = resp.Message;
                        
                        switch (Message) {
                            case "Passed":
                            case "Skipped":
                            case "SoftFailed":
                                var tr = "";
                                
                                if(that.isTrigger){
                                    pf.session.set({ CIPStatus: 1 });
                                }
                                
                                pf.IsConsumerFinancial = true;

                                if (resp.QandA != null)
                                    tr = resp.QandA.TR;

                                if (Message == "SoftFailed" && tr != "UnderAgedUser") {

                                    if (resp.QandA != null ) {
                                        var qandaModel = that.QandAs.toJSON();
                                        qandaModel = resp.QandA;
                                        if (resp.QandA.TR == "questions") {
                                            var qsandAsView = new QsandAsView({
                                                elementName: "#mainRegion",
                                                qamodel    : qandaModel,
                                                Message    : Message,
                                                product    : that.product,
                                                umodel     : that.model.attributes
                                            });
                                            pf.show(qsandAsView);

                                        } else {
                                            var failureView = new FailureView({ model: that.model, Message: Message, gender: "", elementName: "#mainRegion" });
                                            pf.show(failureView);
                                        }
                                    } else {
                                        if(that.isTrigger){
                                            that.reRouteAfterCIP();
                                            return;
                                        }
                                        var failureView = new FailureView({ model: that.model, Message: Message, gender: "", elementName: "#mainRegion" });
                                        pf.show(failureView);
                                    }
                                } else if (resp.AccountGUID != null) {
                                    if(that.isTrigger){
                                        // pf.navigate(that.triggerRoute);
                                        // window.location.href = that.triggerRoute;
                                        that.reRouteAfterCIP();
                                        return;
                                    }

                                    store.setStoreItem(enums.modelsEnum.IsRegistration, { Data: 0 });
                                    
                                    var productSelectionView = new ProductSelectionView({ elementName: "#mainRegion" });
                                    pf.show(productSelectionView);

                                    // pf.require("views/accounts/linknewcard/linknewcard", null, null, true, function () {
                                    //     require(["views/accounts/linknewcard/linknewcard"], function (linknewcard) {
                                    //         pf.show(new linknewcard({ elementName: "#mainRegion" }));
                                    //     });
                                    // });

                                    // var successView;
                                    // switch (that.product) {
                                    //     case enums.cardTypes.GPRDebitCard:
                                    //         successView = new SuccessView();
                                    //         pf.show(successView, "#mainRegion");
                                    //         break;
                                    //     case enums.cardTypes.VirtualCard:
                                    //         that.linkVisa();
                                    //         break;
                                    //     default:
                                    //         successView = new SuccessView();
                                    //         pf.show(successView, "#mainRegion");
                                    //         break;
                                    // }
                                } else {
                                    var failureView = new FailureView({ model: that.model, Message: Message, gender: "", elementName: "#mainRegion" });
                                    pf.show(failureView);
                                }

                                break;
                            case "Failed":                                

                                if (that.numFailuresInSession > 0) {                                    
                                    var failureView = new FailureView({ model: that.model, Message: Message, gender: "", elementName: "#mainRegion" });
                                    pf.show(failureView);
                                } else {
                                    that.numFailuresInSession++;
                                    //show error message
                                    that.$("#continueReg").removeClass("btn-showSpinner").attr('disabled', false);
                                    that.$(".couldNotVerify").removeClass("hidden");
                                }

                                break;
                            default:
                                if (that.numFailuresInSession > 0) {
                                    var failureView = new FailureView({ model: that.model, Message: Message, gender: "", elementName: "#mainRegion" });
                                    pf.show(failureView);
                                } else {
                                    that.numFailuresInSession++;
                                    //show error message
                                    that.$("#continueReg").removeClass("btn-showSpinner").attr('disabled', false);
                                    that.$(".couldNotVerify").removeClass("hidden");
                                }
                                break;
                        }                       
                    },
                    error: function (model, resp) {
                        that.$(".formSection").attr('disabled', false);
                        switch (resp.status) {
                            case 400:
                                var x = that.model;
                                var Message = resp.responseJSON.Message;
                                //if (Message)
                                //   jAlert(Message);
                                if (Message == enums.Errors.CardAttemptLimitReached)
                                    pfdialog.error({ context: this, Body: "For your protection, PayForward limits the number of times someone can attempt to confirm their identity. You’ve reached the maximum number of attempts at this time. Please contact Member Services at 844-904-9273 to resolve this issue.", Title: "Verification Error" });
                                else {

                                    if (that.numFailuresInSession > 0) {
                                        //var failureView = new FailureView({ model: that.model, Message: Message, gender: genderval, elementName: "#mainRegion" });
                                        var failureView = new FailureView({ model: that.model, Message: Message, gender: "", elementName: "#mainRegion" });
                                        pf.show(failureView);
                                    }
                                    else
                                    {
                                        that.numFailuresInSession++;
                                        //show error message
                                        that.$("#continueReg").removeClass("btn-showSpinner").attr('disabled', false);
                                        that.$(".couldNotVerify").removeClass("hidden");
                                        $('html, body').animate({ scrollTop: 0 }, 'slow');
                                     }
                                }
                                //this.loadView(new FailureView({ model: that.model, Message: Message, gender: genderval, elementName: "#mainRegion" }), "#mainRegion");
                                //}
                                break;
                          default:
                              pfdialog.error({ context: this, Body: "Your request was not completed at this moment", Title: "Internal error" });
                          break;
                        }
                    }
                });
            } else {
                this.scrollToFirstError();
            }
        },
        linkVisa: function (e) {
            var visaRedirectView = new VisaRedirect({ elementName: "#mainRegion" });
            pf.show(visaRedirectView);
            
        },
        toggleContinue: function (e) {

            var agreeChkbX = e.target;

            if (agreeChkbX.checked) {
                this.$("#continueReg").removeAttr('disabled');
            }
            else {
                this.$("#continueReg").attr('disabled', true);
            }
        },
        saveToSession: function (e) {

            var that = this;          

            var state = _.find(this.states.models, function (model) {                
                return model.attributes.ID == that.$("#state").val();
            });  
            
            
            var stateA = _.find(this.states.models, function (model) {                
                return model.attributes.ID == that.$("#state").val();
            });  

            var data = {
               // Gender: that.$("#gender").val(),
                Gender: 0,
                AddressLine1: that.$("#addressLine1").val(),
                // AddressLine2: that.$("#addressLine2").val(),
                City: that.$("#City").val(),
                StateID: that.$("#state").val(),
                State: state ? state.Name : "",
                StateAbbreviation: stateA ?stateA.Value : "",
                ZipCode: that.$("#zipCode").val(),
                PhoneNumber: that.$("#homePhone").val() == "" ? "" : that.$("#homePhone").val().replace(/-/gi, ""),
                //Mobile: that.$("#mobile").val() == "" ? "" : that.$("#mobile").val().replace(/-/gi, ""),
                //SecurityQuestions: securityQuestions,
                SSN: this.$("#ssn4").val() == "" ? "" : this.$("#ssn4").val().replace(/-/gi, ""),
                DOB: this.$("#dob").val(),
                Email:pf.session.get("eMail"),
                SMS: this.$('#smsCheckbox').is(":checked")
            }
            this.model.set(data);
            //store.setStoreItemTimer(enums.modelsEnum.FinMbrApplication, { Data: JSON.stringify(data) }, 10);
        },

        validatePhone: function(){
            var phoneString = this.$("#homePhone").val();
            phoneString = phoneString.replace(/-/gi, "");
            this.$("#homePhone").val(phoneString);
        },

        validateApplication: function (e) {
            if (e && e.preventDefault) { e.preventDefault(); }
            if (e && e.stopPropagation) { e.stopPropagation(); }

            var that = this;

            var valid = true;
            var continueApplication = false;
            if (e.target.id == "continueReg")
                continueApplication = true;


            this.patterns = Backbone.Validation.patterns;

            //this.saveToSession(e);            
            var item = null;

            switch (e.target.id) {
                case "firstName":
                    valid = this.validateEach.validateFirstName(continueApplication, e, that);
                    break;
                case "lastName":
                    valid = this.validateEach.validateLastName(continueApplication, e, that);
                    break;
                case "addressLine1":
                    valid = this.validateEach.validateAddressLine1(continueApplication, e, that);
                    break;
                // case "addressLine2":
                //     valid = this.validateEach.validateAddressLine2(continueApplication, e, that);
                    break;
                case "homePhone":
                    valid = this.validateEach.validateHomePhone(continueApplication, e, that);
                    break;
                case "City":
                    valid = this.validateEach.validateCity(continueApplication, e, that);
                    break;
                case "state":
                    valid = this.validateEach.validateState(continueApplication, e, that);
                    break;
                case "zipCode":
                    valid = this.validateEach.validateZipCode(continueApplication, e, that);
                    break;
                case "ssn4":
                    valid = this.validateEach.validateSSN4(continueApplication, e, that);
                    break;
                case "dob":
                    valid = this.validateEach.validateDOB(continueApplication, e, that);
                    break;
                case "cardHldrAgrmt":
                    valid = this.validateEach.validateTermsAccepted(continueApplication,e, that);
                    break;
                case "continueReg":
                    if (!this.validateEach.validateAddressLine1(continueApplication, e, that)) {
                        valid = false;
                    };
                    // if (!this.validateEach.validateAddressLine2(continueApplication, e, that)) {
                    //     valid = false;
                    // };
                    if (!this.validateEach.validateHomePhone(continueApplication, e, that)) {
                        valid = false;
                    };
                    if (!this.validateEach.validateCity(continueApplication, e, that)) {
                        valid = false;
                    };
                    if (!this.validateEach.validateState(continueApplication, e, that)) {
                        valid = false;
                    };
                    if (!this.validateEach.validateZipCode(continueApplication, e, that)) {
                        valid = false;
                    };
                    if (!this.validateEach.validateSSN4(continueApplication, e, that)) {
                        valid = false;
                    };
                    if (!this.validateEach.validateDOB(continueApplication, e, that)) {
                        valid = false;
                    };
                    if (!this.validateEach.validateTermsAccepted(continueApplication,e, that)) {
                        valid = false;
                    };
                    break;
            }
            //switch (e.currentTarget.className) {
            //    case "combodate":
            //        if (!this.validateEach.validateDOB(continueApplication, e, that)) {
            //            valid = false;
            //        }
            //            break;
                    
            //}
            if (valid)
                this.saveToSession(e);
            return valid;
        },
        validateEach: {
            validateFirstName: function (continueApplication, e, that) {
                var item = that.$("#firstName");
                var itemMsg = that.$(".js-errorMsg-names");
                if (item.val() == "" || !item.val()) {                    
                    feedbackError(item, itemMsg, sysText['FV']['required']['firstName']);
                    return false;
                }
                else {                    
                    feedbackValid(item, itemMsg, sysText['FV']['required']['firstName']);
                    if (!continueApplication)
                        that.saveToSession(e);
                    return true;
                }
            },
            validateLastName: function (continueApplication, e, that) {
                var item = that.$("#lastName");
                var itemMsg = that.$(".js-errorMsg-names");
                if (item.val() == "" || !item.val()) {
                    feedbackError(item, itemMsg, sysText['FV']['required']['lastName']);
                    return false;
                }
                else {                    
                    feedbackValid(item, itemMsg, sysText['FV']['required']['lastName']);
                    if (!continueApplication)
                        that.saveToSession(e);
                    return true;
                }
            },
            validateAddressLine1: function (continueApplication, e, that) {
                var item = that.$("#addressLine1");
                var itemMsg = that.$(".js-errorMsg-addressLine1");
                var pattern = /\bbox(?:\b$|([\s|\-]+)?[0-9]+)|(p[\-\.\s]*o[\-\.\s]*|(post office|post)\s)b(\.|ox|in)?\b|(^p[\.]?(o|b)[\.]?$)/;

                if (item.val() == "" || !item.val()) {
                    feedbackError(item, itemMsg, sysText['FV']['required']['address']);
                    return false;
                } else if (pattern.test(item.val().toLowerCase())) {
                    feedbackError(item, itemMsg, "Must be a residential address.");
                    return false;
                } else if(isEmail(item.val())){
                    feedbackError(item, itemMsg, sysText['FV']['required']['address']);
                    return false;
                } else {
                    feedbackValid(item, itemMsg, sysText['FV']['required']['address']);
                    if (!continueApplication)
                        that.saveToSession(e);
                    return true;
                }
            },
            validateAddressLine2: function (continueApplication, e, that) {
                var item = that.$("#addressLine2");
                var itemMsg = that.$(".js-errorMsg-addressLine2");
                var pattern = new RegExp('[PO.]*\\s?B(ox)?.*\\d+', 'i');
                if (!item.val() == "" || item.val()) {
                    if (item.val().match(pattern)) {
                        feedbackError(item, itemMsg, "Must be a residential address.");
                        return false;
                    } else {
                        feedbackValid(item, itemMsg);
                    }
                    if (!continueApplication) {
                        that.saveToSession(e);
                }
                } else {
                    feedbackClear(item, itemMsg);
                }
                return true;
            },
            validateHomePhone: function (continueApplication, e, that) {
                var item = that.$("#homePhone");
                var itemMsg = that.$(".js-errorMsg-phone");
                var ph = item.val();
                // ph = ph.replace(/-/gi, "");
                ph = ph.match(/\d/g);
                if(ph != null)
                    ph = ph.join("");
                if (that.patterns.number.test(ph) == false) {
                    //if (that.patterns.number.test(that.$("#mobile").val().replace(/-/gi, "")) == false) {                    
                    //    return false;
                    //}                    
                    feedbackError(item, itemMsg, sysText['FV']['required']['phoneNumber']);
                    return false;
                }
                else if (ph.length != 10) {                    
                    feedbackError(item, itemMsg, sysText['FV']['invalid']['phoneNumber']);
                    return false;
                }
                ph = ph.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
                item.val(ph);                
                //that.formatPhone(item.val());                
                feedbackValid(item, itemMsg, sysText['FV']['required']['phoneNumber']);
                if (!continueApplication)
                    that.saveToSession(e);
                return true;
            },
            validateCity: function (continueApplication, e, that) {
                var item = that.$("#City");
                var itemMsg = that.$(".js-errorMsg-city");
                if (item.val() == "" || !item.val()) {                    
                    feedbackError(item, itemMsg, sysText['FV']['required']['city']);
                    return false;
                }
                else {                    
                    feedbackValid(item, itemMsg, sysText['FV']['required']['city']);
                    if (!continueApplication)
                        that.saveToSession(e);
                    return true;
                }
            },
            validateState: function (continueApplication, e, that) {
                var item = that.$("#state");
                var itemMsg = that.$(".js-errorMsg-state");
                if (item.val() == "-1" || !item.val()) {                    
                    feedbackError(item, itemMsg, sysText['FV']['required']['state']);
                    return false;
                }
                else {                    
                    feedbackValid(item, itemMsg, sysText['FV']['required']['state']);
                    if (!continueApplication)
                        that.saveToSession(e);
                    return true;
                }
            },
            validateZipCode: function (continueApplication, e, that) {
                var item = that.$("#zipCode");
                var itemMsg = that.$(".js-errorMsg-zip");
                if (item.val() == "" || !item.val()) {                    
                    feedbackError(item, itemMsg, sysText['FV']['required']['zipCode']);
                    return false;
                }
                else if (item.val().length != 5) {                    
                    feedbackError(item, itemMsg, sysText['FV']['invalid']['zipCode']);
                    return false;
                }
                else {
                    var zipValid = false;
                    $.ajax({
                        type: 'GET',
                        async: false,
                        url: pf.lookupsURL + "/ZipCodes/" + item.val(),
                        contentType: "application/json",
                        success: function (resp, model) {
                            that.stateid = resp.StateID;
                            that.$("#state option[value='" + (that.stateid === undefined ? -1 : that.stateid) + "']").attr("selected", "selected");
                            feedbackValid(item, itemMsg, sysText['FV']['invalid']['zipCode']);
                            if (!continueApplication)
                                that.saveToSession(e);
                            zipValid = true;
                        },
                        error: function () {                            
                            feedbackError(item, itemMsg, sysText['FV']['invalid']['zipCode']);
                            zipValid = false;
                        }
                    });

                    return zipValid;
                }
            },
            validateDOB: function (continueApplication, e, that) {
                var item = that.$("#dob");
                var itemMsg = that.$(".js-errorMsg-dob");

                var monthEl = that.$(".month");
                var dayEl = that.$(".day");
                var yearEl = that.$(".year");

                if(!that.isTrigger && !that.eligibility_required){
                    return true;
                }

                if (item.val() == "" || !item.val()) { // at least one select is empty
                    if (that.monthFocused) {
                        if (monthEl.val()) {
                            styleInputValid(monthEl);    
                        } else {
                            styleInputError(monthEl);   
                        }
                    }
                    if (that.dayFocused) {
                        if (dayEl.val()) {
                            styleInputValid(dayEl);    
                        } else {
                            styleInputError(dayEl);   
                        }
                    }
                    if (that.yearFocused) {
                        if (yearEl.val()) {
                            styleInputValid(yearEl);    
                        } else {
                            styleInputError(yearEl);   
                        }
                    }

                    if (that.monthFocused && that.dayFocused && that.yearFocused) {
                        addErrorMsg(itemMsg, sysText['FV']['required']['dob']);
                    }
                }
                else if (item.val()) { // there's a date in there
                    var dateOfBirth = item.val();
                    var arr_dateText = dateOfBirth.split("/");
                    var day = arr_dateText[1];
                    var month = arr_dateText[0];
                    var year = arr_dateText[2];

                    var mydate = new Date(year, month - 1, day);
                    var actual_age = moment().diff(mydate, 'year');

                    if(actual_age < 18 ){                         

                        feedbackError([$(".day"), $(".month"), $(".year")], itemMsg, sysText['FV']['invalid']['dob']);
                            return false;
                    } else {
                        feedbackValid([$(".day"), $(".month"), $(".year")],itemMsg, sysText['FV']['invalid']['dob']);
                        if (!continueApplication)
                            that.saveToSession(e);
                        return true;
                    }
                } else { //fallback error
                    feedbackValid([$(".day"), $(".month"), $(".year")], itemMsg, sysText['FV']['invalid']['dob']);
                    if (!continueApplication)
                        that.saveToSession(e);
                    return true;
                }
            },
            //validateSSN: function (continueApplication, e, that) {
            //    var item = that.$("#ssn4");
            //    var ssn = item.val();
            //    ssn = ssn.replace(/-/gi, "");
            //    that.model.set({ 'SSN': ssn });
            //    var isModelValid = that.model.isValid(true);
            //    var isValid = that.model.isValid('SSN');
            //    //var errors = that.model.preValidate({ SSN: ssn});
            //    if (that.patterns.number.test(ssn) == false) {
            //        that.addTooltip(item, sysText['FV']['required']['ssn4']);
            //        return false;
            //    }
            //    else if (ssn.length != 9) {
            //        that.addTooltip(item, sysText['FV']['invalid']['ssn4']);
            //        return false;
            //    }
            //    else {
            //        ssn = item.val();
            //        ssn = ssn.replace(/(\d{3})(\d{2})(\d{4})/, '$1-$2-$3');
            //        item.val(ssn);
            //        that.removeTooltip(item);
            //        if (!continueApplication)
            //            that.saveToSession(e);
            //        return true;
            //    }
            //},
            validateSSN4: function (continueApplication, e, that) {
                var item = that.$("#ssn4");
                var itemMsg = that.$(".js-errorMsg-ssn4");
                var ssn = item.val();

                //ssn = ssn.replace(/-/gi, "");
                
                that.model.set({ 'SSN4': ssn });
                var isModelValid = that.model.isValid(true);
                var isValid = that.model.isValid('SSN4');
                
                //var errors = that.model.preValidate({ SSN: ssn});

                if(!that.isTrigger && !that.eligibility_required){
                    return true;
                }
                
                if (that.patterns.number.test(ssn) == false) {                    
                    feedbackError(item, itemMsg, sysText['FV']['required']['ssn4']);
                    return false;
                }
                else if (ssn.length != 4) {                    
                    feedbackError(item, itemMsg, sysText['FV']['invalid']['ssn4']);
                    return false;
                }
                else {
                    ssn = item.val();
                    //ssn = ssn.replace(/(\d{3})(\d{2})(\d{4})/, '$1-$2-$3');
                    item.val(ssn);                    
                    feedbackValid(item, itemMsg, sysText['FV']['invalid']['ssn4']);
                    if (!continueApplication)
                        that.saveToSession(e);
                    return true;
                }
            },
            validateTermsAccepted: function (continueApplication,e, that) {
                var item = that.$("#cardHldrAgrmt");
                var itemMsg = that.$(".js-errorMsg-terms");
                var value = item.val();
                if (item[0].checked == true) {
                    feedbackValid(item, itemMsg);
                    return true;
                }
                else {
                    feedbackError(item, itemMsg, sysText['FV']['required']['acceptTerms']);
                    return false;
                }
            },
        },
        formatPhone: function (s) {

            var item = this.$("#homePhone");            
            var s2 = ("" + s).replace(/\D/g, '');
            var m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
            var value = (!m) ? null : "(" + m[1] + ") " + m[2] + "-" + m[3];
            this.$("#homePhone").val(value);

        },
        getSecurityQuestion: function (questionNumber) {

            var selected = _.find(that.securityQuestions.models, function (model) {
                return model.attributes.SecurityQuestionID == that.$("#questionSet" + questionNumber).val();
            });
            selected.set("Answer", that.$("#answerSet" + questionNumber).val());

            var securityQuestion = new SecurityQuestion();
            selected.set("Answer", that.$("#answerSet" + questionNumber).val());
            selected.set("Answer", that.$("#answerSet" + questionNumber).val());
            selected.set("Answer", that.$("#answerSet" + questionNumber).val());
            selected.set("Answer", that.$("#answerSet" + questionNumber).val());

            return securityQuestion;
        },

        addTooltip: function (selector, errorMessage,position) {
            var item = selector;
            item.tooltipster({
                 position: 'right'
            });
            //item.addClass("tooltipstered");
            item.addClass("hasError");
            item.tooltipster('enable');
            item.tooltipster("content", errorMessage);
        },
        removeTooltip: function (selector) {
            var item = selector;
            item.tooltipster();
            item.removeClass("hasError");
            item.tooltipster("hide");
            item.tooltipster('disable');
            //item.removeClass("tooltipstered");
        },
        showToolTip: function (e) {
            var item = e.target;
            if (item.tooltipster) {
                item.tooltipster('enable');
                item.tooltipster("show");
            }
        },
        scrollToFirstError: function () {
            var animationTime = 400;
            var firstError = this.$(".hasError:visible:first");
            if (firstError && firstError.offset() && firstError.offset().top)
                $('html, body').animate({
                    scrollTop: firstError.offset().top -50
                }, animationTime);
            // firstError.focus().delay(animationTime);
        },
        contactUs: function (e) {
            window.open("", "_blank");
        },
        showAgreement: function(e){
            if (this.product == enums.cardTypes.VirtualCard)
            {
                window.open("#accountholderagreement", "_blank");
            }
            else
            {
                window.open("#cardholderagreement", "_blank");
            }

        },
        monthTouched: function(e) {
            this.monthFocused = true;
            this.validateEach.validateDOB(null, e, this);
        },
        dayTouched: function(e) {
            this.dayFocused = true;
            this.validateEach.validateDOB(null, e, this);
        },
        yearTouched: function(e) {
            this.yearFocused = true;
            this.validateEach.validateDOB(null, e, this);
        },
        setState:function(e){

        },
        close: function () {
        }
    });
});

